<template>
    <i @click="toggleFavourite()"
        class="job__favourite fa"
        :class="{
        'fa-star': currentState,
        'fa-star-o': ! currentState
    }"></i>
</template>

<script>
export default {
    props: [
        'endpoint',
        'state',
    ],

    data() {
        return {
            currentState: false
        }
    },

    methods: {
        toggleFavourite() {
            axios
                .patch(this.endpoint)
                .then(response => {
                    this.currentState = response.data.status;
                    if (this.currentState) {
                        Notify.info('Nabídka byla přidána do oblíbených');
                    } else {
                        Notify.info('Nabídka byla odebrána z oblíbených');
                    }
                })
                .catch(response => alert('error'));
        }
    },

    mounted() {
        this.currentState = this.state;
    }
}
</script>

<style>
    .job__favourite {
        display: inline-block;
        margin: 5px;
        transform: rotate(25deg);
        cursor: pointer;
        color: #b21d31;
    }
</style>
